import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	timeLabel: {
		id: 'eoc.common.ui.date-time-picker.time-label.no-translate',
		defaultMessage:
			'{label} time for the {index, select, 1 {1st} 2 {2nd} 3{3rd} other {{index, number}th}} time slot ',
		description: 'Accessibility label of nth time picker in day time interval',
	},
	dayLabel: {
		id: 'eoc.common.ui.date-time-picker.day-label.no-translate',
		defaultMessage:
			'{label} day for the {index, select, 1 {1st} 2 {2nd} 3{3rd} other {{index, number}th}} time slot ',
		description: 'Accessibility label of nth day picker in day time interval',
	},
});

export default messages;
